import { render, staticRenderFns } from "./BasketResellerOptions.vue?vue&type=template&id=b2ea5f24"
import script from "./BasketResellerOptions.vue?vue&type=script&lang=js"
export * from "./BasketResellerOptions.vue?vue&type=script&lang=js"
import style0 from "./BasketResellerOptions.vue?vue&type=style&index=0&id=b2ea5f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports